import React from 'react';
import PropTypes from 'prop-types';
import Snackbar from '@material-ui/core/Snackbar';
import MessageContentWrapper from './MessageContent';

const AlertMessage = ({
  open, handleClose, variant, message, duration,
}) => (
  <Snackbar
    anchorOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    open={open}
    autoHideDuration={duration}
    onClose={handleClose}
  >
    <MessageContentWrapper onClose={handleClose} variant={variant} message={message} />
  </Snackbar>
);

AlertMessage.defaultProps = {
  variant: 'info',
  message: '',
  duration: 5000,
};

AlertMessage.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  variant: PropTypes.oneOf(['success', 'warning', 'error', 'info']),
  message: PropTypes.string,
  duration: PropTypes.number,
};

export default AlertMessage;
